import { FC, ReactElement, useEffect } from 'react'

import { EditShiftTimeForm } from '../../../containers'
import { Period } from '../../../entities/Period/Period'
import trans from '../../../helpers/trans'
import { deleteShiftPlanning, editConceptShiftPlanningTime } from '../../../redux/shiftPlanning/shiftPlanningActions'
import { setIsDeleteSuccessful, setIsEditSuccessful } from '../../../redux/shiftPlanning/shiftPlanningReducer'
import { useTypedDispatch, useTypedSelector } from '../../../redux/store'
import { setToast } from '../../../redux/toasts/toastsReducer'
import { ToastType } from '../../../types'

interface ConnectedEditShiftTimeFormProps {
    shiftId: string;
    period: Period;
    onClose: () => void;
    className?: string;
}

const ConnectedEditShiftPlanningTimeForm: FC<ConnectedEditShiftTimeFormProps> = ({
    shiftId,
    period,
    onClose,
    className = '',
}): ReactElement => {
    const dispatch = useTypedDispatch()

    const { isEditSuccessful, isDeleteSuccessful } = useTypedSelector(state => state.shiftPlanningReducer)

    const handleDeleteButtonClick = (): void => {
        dispatch(deleteShiftPlanning(shiftId, false))
    }

    const handleSubmit = (value: Period): void => {
        dispatch(editConceptShiftPlanningTime({ period: value }, shiftId))
    }

    useEffect((): void => {
        if (isEditSuccessful) {
            onClose()

            dispatch(setIsEditSuccessful(false))
            dispatch(setToast({
                text: trans('containers.forms.editShiftTimeForm.editShiftTimeSuccess'),
                type: ToastType.pass,
            }))
        }
    }, [isEditSuccessful])

    useEffect((): void => {
        if (isDeleteSuccessful) {
            onClose()

            dispatch(setIsDeleteSuccessful(false))
            dispatch(setToast({
                text: trans('containers.forms.editShiftTimeForm.deleteShiftSuccess'),
                type: ToastType.pass,
            }))
        }
    }, [isDeleteSuccessful])

    return (
        <EditShiftTimeForm
            period={period}
            onSubmit={handleSubmit}
            onDeleteButtonClick={handleDeleteButtonClick}
            onCancel={onClose}
            className={className}
        />
    )
}

export default ConnectedEditShiftPlanningTimeForm
